import React from 'react';

type LoadingContainerProps = {
  className?: string;
  state?: boolean;
};

const LoadingContainer = ({ state = false, className = '' }: LoadingContainerProps) => {
  return (
    <div
      className={`loading-container ${
        state ? 'd-flex' : 'd-none'
      } justify-content-center ${className}`}>
      <span className="ecs-font-icon-act-loading" />
    </div>
  );
};

export default LoadingContainer;
